import request from '@/utils/request'

export function clearCache() {
  return request({
    url: '/system/clear-cache',
    method: 'post'
  })
}
export function getWarningUnRead() {
  return request({
    url: '/collectData/getWarningUnRead',
    method: 'get'
  })
}
